const OperatorEnum = [
  { value: 10007, text: 'IN' },
  { value: 10001, text: 'EQUAL' },
  { value: 10002, text: 'NOT EQUAL' },
  { value: 10003, text: 'LESS THAN' },
  { value: 10004, text: 'LESS THAN OR EQUAL' },
  { value: 10005, text: 'GREATER THAN' },
  { value: 10006, text: 'GREATER THAN OR EQUAL' },
  { value: 10008, text: 'NOT IN' },
  { value: 10009, text: 'CONTAIN' },
  { value: 10010, text: 'NOT CONTAIN' },
  { value: 100011, text: 'BEGIN WITH' },
  { value: 10012, text: 'NOT BEGIN WITH' },
  { value: 10013, text: 'END WITH' },
  { value: 10014, text: 'NOT END WITH' },
  { value: 10015, text: 'LENGTH EQ' }
]

export default OperatorEnum
